<template>
  <Content class="content">
    <div>
      供应商系统
      <div style="float:right">
        <span style="font-size:20px">{{suppName}}</span>
        <Button
          style="margin-right:10px;margin-left:10px"
          @click="clickChagnePwd"
        >修改密码</Button>
        <Button @click="clickLogout">退出登录</Button>

      </div>

    </div>

    <QueryForm
      style="margin-top:40px"
      @on-query="onQuery"
      @on-insert="onInsert"
    />
    <List
      :data="list"
      :token="token"
      @on-detail="onItemDetail"
      @on-edit="onItemEdit"
      @on-delete="onItemDelete"
      :page-size="queryData.pageSize"
      :change="onChangePage"
      :total="total"
      :current="queryData.page"
    />
    <DetailModal
      v-model="detailModal"
      :data="detailData"
      :token="token"
      ref="detailModalRef"
    />
    <!-- <EditModal
      v-model="editModal"
      ref="editModalRef"
      @on-save="onEditSave"
    /> -->
    <ChangePwdModal
      v-model="changePwdModal"
      @on-save="onPwdSave"
    />
  </Content>
</template>

<script>
import List from './components/list'
import DetailModal from './components/detailModal'
import EditModal from './components/editModal'
import QueryForm from './components/queryForm'
import ChangePwdModal from './components/changePwdModal'
import {clearSession, ensureSessionActive, startSessionGuard} from '@/plugin/callApi'

export default {
  name: 'SupplierSkuQuery',
  components: {
    List,DetailModal,EditModal,QueryForm,ChangePwdModal
  },
  data () {
    return {
      list: [],
      changePwdModal: false,
      editModal: false,
      detailData: {},
      detailModal: false,
      queryData: {
        page: 1,
        pageSize: 20
      },
      total: 0,
      suppName: '',
      token: '',
      sessionGuardStop: null
    }
  },
  created () {
    let userData = null
    try {
      userData = JSON.parse(sessionStorage.getItem('userData'))
    } catch (e) {
      userData = null
    }
    if (userData == null || !ensureSessionActive(this)) {
      this.$router.replace({
        path: '/'
      })
      return
    }
    this.suppName = userData.cusName
    this.token = userData.downToken
  },
  mounted () {
    if (sessionStorage.getItem('userData')) {
      this.sessionGuardStop = startSessionGuard(this)
    }
  },
  beforeDestroy () {
    if (this.sessionGuardStop) {
      this.sessionGuardStop()
      this.sessionGuardStop = null
    }
  },
  methods: {
    onQuery (queryData) {
      this.queryData={
        ...this.queryData,
        ...queryData,
        page: 1
      }
      this.loadData()
    },
    onInsert () {
      this.$refs['editModalRef'].setData({})
      this.editModal=true
    },
    onItemDetail (p) {
      this.detailData=p.row
      this.detailModal=true
    },
    onItemEdit (p) {
      this.$refs['editModalRef'].setData(Object.assign({},p.row))
      this.editModal=true
    },
    onItemDelete (p) {
      this.$Modal.confirm({
        title: '删除提示',
        content: '<p>确定要进行删除操作吗?</p>',
        onOk: () => {
          this.httpDeleteById(p.row.id)
        }
      });
    },
    onChangePage (page) {
      this.queryData.page=page
      this.loadData()
    },
    onEditSave (data) {
      this.$fetch('CusFahuo/save',data,'POST')
        .then(res => {
          this.$Message.success('保存成功')
          this.loadData()
        })
    },
    loadData () {
      this.$fetch('CusFahuo/getListForCus',this.queryData).then(res => {
        this.list=res.data.list
        this.total=res.data.total
      })
    },
    httpDeleteById (id) {
      this.$fetch('CusFahuo/del',{id}).then(res => {
        this.$Message.success('删除成功')
        this.loadData()
      })
    },
    clickLogout () {
      clearSession()
      this.$router.replace({
        path: '/'
      })
    },
    onPwdSave ({pwd}) {
      this.$fetch('CusLogin/uptCusPwd',{
        loginPwd: pwd
      }).then(res => {
        this.$Message.success('提交成功')
        this.changePwdModal=false
      })
    },
    clickChagnePwd () {
      this.changePwdModal=true
    }
  }

}
</script>
<style scoped>
.content {
  padding: 20px;
  margin: 20px;
  background: #fff;
}
</style>
